import type { ReactNode } from 'react';

import type { PaginaDoHistorico } from '../api/historico';
import { HistoricoDeAlteracoes } from './HistoricoDeAlteracoes';

/** Uma página de Configurações com o histórico de alterações dela na coluna da direita. */
export function PaginaComHistorico({ pagina, children }: { pagina: PaginaDoHistorico; children: ReactNode }) {
    return (
        <div className="pagina-com-historico">
            <div className="pagina-com-historico-conteudo">{children}</div>
            <HistoricoDeAlteracoes pagina={pagina} />
        </div>
    );
}
